import { useCallback } from 'react';
import { mediatorAtom, useSetMediatorState } from 'hooks/globals/useMediatorAtom';
import useFeatureToggles from 'hooks/user/useFeatureToggles';

// Since we need to support legacy-none-react views. The source of truth for powerstep state will live here were both legacy and react has access to it.
export const PowerstepMediatorAtom = mediatorAtom<{ isOpen: boolean; productIds: number[]; storeId?: number }>({
    isOpen: false,
    productIds: [],
    storeId: undefined
});

export default function usePowerstep(): [(productIds: number[], storeId?: number) => void, () => void] {
    const setPowerstepMediatorAtom = useSetMediatorState(PowerstepMediatorAtom);
    const { powerstepEnabled } = useFeatureToggles();

    const close = useCallback(() => {
        if (powerstepEnabled) setPowerstepMediatorAtom({ isOpen: false, productIds: [], storeId: undefined });
    }, [setPowerstepMediatorAtom]);

    const open = useCallback(
        (productIds: number[], storeId?: number) => {
            if (powerstepEnabled) setPowerstepMediatorAtom({ isOpen: true, productIds, storeId });
        },
        [setPowerstepMediatorAtom]
    );

    return [open, close];
}

// Legacy functions for opening the react-powerstep outside of React.
export const legacyOpenPowerstep = (productIds: number[]) => PowerstepMediatorAtom.set({ isOpen: true, productIds });
export const legacyClosePowerstep = () => PowerstepMediatorAtom.set({ isOpen: false, productIds: [] });
